"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@trs/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDraftWysiwyg = require("react-draft-wysiwyg");
require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");
var _InputError = _interopRequireDefault(require("../errors/InputError"));
var _icon = _interopRequireDefault(require("../icon"));
var _RichTextarea2 = _interopRequireDefault(require("./RichTextarea.style"));
var _RichTextarea3 = require("./RichTextarea.helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RichTextarea = /*#__PURE__*/function (_Component) {
  function RichTextarea(props) {
    var _this;
    _classCallCheck(this, RichTextarea);
    _this = _callSuper(this, RichTextarea, [props]);
    _defineProperty(_this, "onEditorStateChange", function (editorState) {
      var onChange = _this.props.onChange;
      var initialValue = _this.state.initialValue;
      var markup = (0, _RichTextarea3.getMarkupFromEditorState)(editorState);
      var plainText = editorState.getCurrentContent().getPlainText();
      _this.setState({
        editorState: editorState
      });
      _this.setState({
        isDirty: markup !== initialValue
      }, onChange(markup, plainText));
    });
    var _initialValue = props.initialValue ? (0, _utils.safeTrim)(props.initialValue) : undefined;
    var value = (0, _utils.safeTrim)(props.value);
    _this.state = {
      editorState: (0, _RichTextarea3.getEditorState)(value),
      initialValue: _initialValue || value,
      isDirty: false,
      hasLengthError: false
    };
    return _this;
  }
  _inherits(RichTextarea, _Component);
  return _createClass(RichTextarea, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        editorState = _this$state.editorState,
        hasLengthError = _this$state.hasLengthError;
      var _this$props = this.props,
        readOnly = _this$props.readOnly,
        error = _this$props.error,
        disabled = _this$props.disabled,
        ariaDescribedBy = _this$props.ariaDescribedBy,
        placeholder = _this$props.placeholder,
        placeholderPosition = _this$props.placeholderPosition,
        className = _this$props.className,
        toolbar = _this$props.toolbar,
        expanded = _this$props.expanded,
        onToggleText = _this$props.onToggleText,
        value = _this$props.value,
        collapsableText = _this$props.collapsableText,
        onBlur = _this$props.onBlur;
      var hasError = !(0, _utils.isBlank)(error);
      var textLength = value ? value.length : 0;
      return /*#__PURE__*/_react["default"].createElement(_RichTextarea2["default"], {
        hasError: hasError || hasLengthError,
        isReadOnly: readOnly,
        isDisabled: disabled,
        className: className,
        placeholderPosition: placeholderPosition
      }, this.props.childContainer, !(collapsableText && _utils.isMobile && textLength === 0) && /*#__PURE__*/_react["default"].createElement(_reactDraftWysiwyg.Editor, {
        toolbarHidden: readOnly || disabled,
        editorState: editorState,
        readOnly: readOnly || disabled,
        wrapperClassName: "wrapper-class",
        editorClassName: "editor-class",
        toolbarClassName: "toolbar-class",
        onEditorStateChange: this.onEditorStateChange,
        onBlur: onBlur,
        toolbar: (0, _RichTextarea3.getToolbarConfig)(toolbar),
        ariaDescribedBy: ariaDescribedBy,
        placeholder: placeholder,
        stripPastedStyles: true
      }), hasError && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        className: "rdw-inputError",
        message: error
      }), disabled && collapsableText && _utils.isMobile && /*#__PURE__*/_react["default"].createElement("div", {
        className: "collapsable-icon-container"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-chevron-".concat(expanded ? 'up' : 'down'),
        collapsable: true,
        hasError: hasError || hasLengthError,
        onClick: onToggleText,
        size: 12
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var initialValue = props.initialValue ? (0, _utils.safeTrim)(props.initialValue) : undefined;
      var value = (0, _utils.safeTrim)(props.value);

      // Changing the initial value the text will be reverted to if the prop is passed.
      if (initialValue && initialValue !== state.initialValue) {
        var editorState = (0, _RichTextarea3.getEditorState)(value);
        return {
          editorState: editorState,
          initialValue: initialValue,
          isDirty: false
        };
      }

      // Reverts the text to the initial value.
      if (value === state.initialValue && state.isDirty) {
        var _editorState = (0, _RichTextarea3.getEditorState)(value);
        return {
          editorState: _editorState,
          initialValue: value,
          isDirty: false
        };
      }

      // Changes text to initial value for mobile view with collapsable text
      if (value !== state.initialValue && props.collapsableText) {
        var _editorState2 = (0, _RichTextarea3.getEditorState)(value);
        return {
          editorState: _editorState2,
          initialValue: value
        };
      }
      return null;
    }
  }]);
}(_react.Component);
RichTextarea.propTypes = {
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  editorState: _propTypes["default"].shape({}),
  initialValue: _propTypes["default"].string,
  value: _propTypes["default"].string,
  ariaDescribedBy: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  placeholderPosition: _propTypes["default"].oneOf(['top', 'center']),
  className: _propTypes["default"].string,
  toolbar: _propTypes["default"].shape({}),
  childContainer: _propTypes["default"].element,
  expanded: _propTypes["default"].bool,
  onToggleText: _propTypes["default"].func,
  collapsableText: _propTypes["default"].bool,
  onBlur: _propTypes["default"].func
};
RichTextarea.defaultProps = {
  disabled: false,
  error: undefined,
  readOnly: false,
  onChange: function onChange() {},
  editorState: undefined,
  initialValue: undefined,
  value: undefined,
  placeholder: '',
  placeholderPosition: 'center',
  className: '',
  toolbar: {
    options: []
  },
  childContainer: null,
  expanded: false,
  onToggleText: function onToggleText() {
    return null;
  },
  collapsableText: false,
  ariaDescribedBy: '',
  onBlur: undefined
};
var _default = exports["default"] = RichTextarea;